import { generateCustomGridAreasCss } from '@evidia/components';
import styled from 'styled-components';
import type { ColumnsWithGridKey } from './SimpleTable';
import { getIterativeProps } from './utils';

const GridContainer = styled.div<{ $gridMap: string[][] }>`
	display: grid;

	${({ $gridMap }) => generateCustomGridAreasCss($gridMap)};

	align-items: center;
	gap: 5px;
`;

type Props = {
	gridMap: string[][];
	columns: ColumnsWithGridKey;
	record: any;
};

export const MobileRowItem = ({ gridMap, columns, record }: Props) => (
	<GridContainer $gridMap={gridMap}>
		{columns.map((column, index) => {
			const data = getIterativeProps(record, column.dataIndex);

			return (
				<div
					key={String(column.gridKey)}
					style={{
						gridArea: column.gridKey,
						justifySelf: column.justifySelf,
						alignSelf: column.alignSelf,
					}}
				>
					{column.render ? column.render(data, record, index) : data}
				</div>
			);
		})}
	</GridContainer>
);
